import React, { Suspense } from "react";
import { useRoutes } from "react-router-dom";
import { DefaultLayout, VerticalLayout, HorizontalLayout, DetachedLayout, FullLayout } from "layouts";
import PrivateRoute from "./PrivateRoute";
import Root from "./Root";
import { LayoutTypes } from "appConstants";
import { useRedux } from "hooks";
import CustomerCICReportingCreateForm from "pages/registration/customerCICReporting/CreateForm";

const UserPage = React.lazy(() => import("pages/master/user/List"));
const CreateUserPage = React.lazy(() => import("pages/master/user/CreateForm"));
const UpdateUserPage = React.lazy(() => import("pages/master/user/UpdateForm"));
const DetailUserPage = React.lazy(() => import("pages/master/user/Detail"));

//roles

const UserRolePage = React.lazy(() => import("pages/master/userRoles/List"));
const CreateUserRolePage = React.lazy(() => import("pages/master/userRoles/CreateForm"));
const UpdateUserRolePage = React.lazy(() => import("pages/master/userRoles/UpdateForm"));
const DetailUserRolePage = React.lazy(() => import("pages/master/userRoles/Detail"));

const CurrencyPage = React.lazy(() => import("pages/master/currency/List"));
const CreateCurrencyPage = React.lazy(() => import("pages/master/currency/CreateForm"));
const DetailCurrencyPage = React.lazy(() => import("pages/master/currency/Detail"));
const UpdateCurrencyPage = React.lazy(() => import("pages/master/currency/UpdateForm"));

const CreateBaseRatePage = React.lazy(() => import("pages/master/baseRate/CreateForm"));
const BaseRatePage = React.lazy(() => import("pages/master/baseRate/List"));
const DetailBaseRatePage = React.lazy(() => import("pages/master/baseRate/Detail"));
const UpdateBaseRatePage = React.lazy(() => import("pages/master/baseRate/UpdateForm"));

const HolidayPage = React.lazy(() => import("pages/master/holiday/List"));
const CreateHolidayPage = React.lazy(() => import("pages/master/holiday/CreateForm"));
const DetailHolidayPage = React.lazy(() => import("pages/master/holiday/Detail"));
const UpdateHolidayPage = React.lazy(() => import("pages/master/holiday/UpdateForm"));

const HolidayBatchPage = React.lazy(() => import("pages/master/holiday-batch/List"));
const DetailHolidayBatchPage = React.lazy(() => import("pages/master/holiday-batch/Detail"));
const UpdateHolidayBatchPage = React.lazy(() => import("pages/master/holiday-batch/UpdateForm"));

const SystemParametersPage = React.lazy(() => import("pages/master/systemParameters/List"));
const DetailSystemParameterPage = React.lazy(() => import("pages/master/systemParameters/Detail"));
const UpdateSystemParameterPage = React.lazy(() => import("pages/master/systemParameters/UpdateForm"));

const BranchPage = React.lazy(() => import("pages/master/branch/List"));
const CreateBranchPage = React.lazy(() => import("pages/master/branch/CreateForm"));
const DetailBranchPage = React.lazy(() => import("pages/master/branch/Detail"));
const UpdateBranchPage = React.lazy(() => import("pages/master/branch/UpdateForm"));

const CountryPage = React.lazy(() => import("pages/master/country/List"));
const CreateCountryPage = React.lazy(() => import("pages/master/country/CreateForm"));
const DeatilCountryPage = React.lazy(() => import("pages/master/country/Detail"));
const UpdateCountryPage = React.lazy(() => import("pages/master/country/UpdateForm"));

const StatePage = React.lazy(() => import("pages/master/state/List"));
const CreateStatePage = React.lazy(() => import("pages/master/state/CreateForm"));
const DetailStatePage = React.lazy(() => import("pages/master/state/Detail"));
const UpdateStatePage = React.lazy(() => import("pages/master/state/UpdateForm"));

const CityPage = React.lazy(() => import("pages/master/city/List"));
const CreateCityPage = React.lazy(() => import("pages/master/city/CreateForm"));
const DetailCityPage = React.lazy(() => import("pages/master/city/Detail"));
const UpdateCityPage = React.lazy(() => import("pages/master/city/UpdateForm"));

const CustomersPage = React.lazy(() => import("pages/registration/customer/List"));
const CreateCustomersPage = React.lazy(() => import("pages/registration/customer/CreateForm"));
const customerDetailPage = React.lazy(() => import("pages/registration/customer/Detail"));
const UpdateCustomerPage = React.lazy(() => import("pages/registration/customer/UpdateForm"));

const CustomerCICReportingPage = React.lazy(() => import("pages/registration/customerCICReporting/List"));
const CreateCustomerCICReportingPage = React.lazy(() => import("pages/registration/customerCICReporting/CreateForm"));
const UpdateCustomerCICReportingPage = React.lazy(() => import("pages/registration/customerCICReporting/UpdateForm"));
const CustomerCICReportingDetailPage = React.lazy(() => import("pages/registration/customerCICReporting/Detail"));

const unAuthorizedPage = React.lazy(() => import("pages/error/UnAuthorisedError"));

const BulkCustomersListPage = React.lazy(() => import("pages/registration/bulkCustomer/List"));
const BulkCustomersDetailPage = React.lazy(() => import("pages/registration/bulkCustomer/Detail"));

const BulkCustomerCicReportingListPage = React.lazy(() => import("pages/registration/bulkCustomerCicReporting/List"));
const BulkCustomerCicReportingDetailPage = React.lazy(() => import("pages/registration/bulkCustomerCicReporting/Detail"));

// programme
const programmePage = React.lazy(() => import("pages/registration/financingPrograms/List"));
const CreateProgrammePage = React.lazy(() => import("pages/registration/financingPrograms/CreateForm"));
const ProgrammeDetailPage = React.lazy(() => import("pages/registration/financingPrograms/Detail"));
const UpdateProgrammePage = React.lazy(() => import("pages/registration/financingPrograms/UpdateForm"));

// Bulk- programme
const bulkProgrammePage = React.lazy(() => import("pages/registration/bulkFinancingProgramme/List"));
const bulkProgrammeDetailPage = React.lazy(() => import("pages/registration/bulkFinancingProgramme/Detail"));

//relationship-Managers

const RMCreatePage = React.lazy(() => import("pages/master/relationshipManagers/CreateForm"));
const RMPage = React.lazy(() => import("pages/master/relationshipManagers/List"));
const RMUpdatePage = React.lazy(() => import("pages/master/relationshipManagers/UpdateForm"));
const RMDetailPage = React.lazy(() => import("pages/master/relationshipManagers/Detail"));

// LOV
const LOVPage = React.lazy(() => import("pages/master/LOV/List"));
const CreateLOVPage = React.lazy(() => import("pages/master/LOV/CreateForm"));
const LOVDetailPage = React.lazy(() => import("pages/master/LOV/Detail"));
const UpdateLOVPage = React.lazy(() => import("pages/master/LOV/UpdateForm"));

// product_type
const productTypePage = React.lazy(() => import("pages/master/productType/List"));
const CreateproductTypePage = React.lazy(() => import("pages/master/productType/CreateForm"));
const ProductTypeDetailPage = React.lazy(() => import("pages/master/productType/Detail"));
const UpdateproductTypePage = React.lazy(() => import("pages/master/productType/UpdateForm"));
// const RMUpdateUserPage = React.lazy(() => import("pages/master/relationshipManagers/RMUpdateForm"));

// gl Account
const GlAccountListPage = React.lazy(() => import("pages/master/glaccount/List"));
const CreateGlAccountPage = React.lazy(() => import("pages/master/glaccount/CreateForm"));
const GlAccountDetailPage = React.lazy(() => import("pages/master/glaccount/Detail"));
const UpdateGlAccountPage = React.lazy(() => import("pages/master/glaccount/UpdateForm"));

//co-lender-financer
const CoLenderFinancierListPage = React.lazy(() => import("pages/master/co-lenderFinancier/List"));
const CreateCoLenderFinancierPage = React.lazy(() => import("pages/master/co-lenderFinancier/CreateForm"));
const CoLenderFinancierDetailPage = React.lazy(() => import("pages/master/co-lenderFinancier/Detail"));
const UpdateCoLenderFinancierPage = React.lazy(() => import("pages/master/co-lenderFinancier/UpdateForm"));

// lazy load all the views

// auth
const Login = React.lazy(() => import("pages/account/Login"));
const Logout = React.lazy(() => import("pages/account/Logout"));
const Register = React.lazy(() => import("pages/account/Register"));
const Confirm = React.lazy(() => import("pages/account/Confirm"));
const ForgetPassword = React.lazy(() => import("pages/account/ForgetPassword"));
const LockScreen = React.lazy(() => import("pages/account/LockScreen"));

const Logout2 = React.lazy(() => import("pages/account/Logout2"));
const Register2 = React.lazy(() => import("pages/account/Register2"));
const Confirm2 = React.lazy(() => import("pages/account/Confirm2"));
const ForgetPassword2 = React.lazy(() => import("pages/account/ForgetPassword2"));
const LockScreen2 = React.lazy(() => import("pages/account/LockScreen2"));
const SSOConsumeRedirect = React.lazy(() => import("pages/account/SSOConsumeRedirect"))
const SSOOtpHandle = React.lazy(() => import("pages/account/SSOOtpHandle"))

// dashboard
const DashBoardPage = React.lazy(() => import("pages/dashboard/my/List"));

// pages
const ErrorPageNotFound = React.lazy(() => import("pages/error/PageNotFound"));
const ErrorPageNotFoundSecondary = React.lazy(() => import("pages/error/PageNotFoundSecondary"));
const ErrorPageNotFoundAlt = React.lazy(() => import("pages/error/PageNotFoundAlt"));
const ServerError = React.lazy(() => import("pages/error/ServerError"));

// CustomerContactUpdateForm
//customerUpdate
const PromoterDirectorDetailPage = React.lazy(() => import("pages/registration/promoterDirectors/Details"));
const PromoterDirectorUpdateForm = React.lazy(() => import("pages/registration/promoterDirectors/UpdateForm"));

const KeyManagementPersonnelDetailPage = React.lazy(() => import("pages/registration/keyManagementPersonnel/Details"));
const KeyManagementPersonnelUpdateForm = React.lazy(() => import("pages/registration/keyManagementPersonnel/UpdateForm"));

const PartnerDetailPage = React.lazy(() => import("pages/registration/partnerDetail/Details"));
const PartnerUpdateForm = React.lazy(() => import("pages/registration/partnerDetail/UpdateForm"));

// ListCustomerCummications
const UpdateCustomerCummicationsPage = React.lazy(() => import("pages/registration/customerCummications/UpdateForm"));
const CustomerCummicationsDetailPage = React.lazy(() => import("pages/registration/customerCummications/Detail"));

//address
const AddressDetailPage = React.lazy(() => import("pages/registration/customrAddress/Details"));
const AddressUpdateForm = React.lazy(() => import("pages/registration/customrAddress/UpdateForm"));

// UpdateCustomerCummicationsPage

//beneficiary
const beneficiaryDetailPage = React.lazy(() => import("pages/registration/customerBeneficiary/Details"));

const beneficiaryProgrammeDetailPage = React.lazy(() => import("pages/registration/customerBeneficiaryProgramme/Details"));
const CustomerBeneficiaryProgrammeUpdateForm = React.lazy(() => import("pages/registration/customerBeneficiaryProgramme/UpdateForm"));

//charge

const ReceivableChargeListPage = React.lazy(() => import("pages/charges/receivableCharge/List"));
const CreateReceivableChargePage = React.lazy(() => import("pages/charges/receivableCharge/CreateForm"));
const ReceivableChargeDetailPage = React.lazy(() => import("pages/charges/receivableCharge/Detail"));
const UpdateReceivableChargePage = React.lazy(() => import("pages/charges/receivableCharge/UpdateForm"));

const ChargeSettlementListPage = React.lazy(() => import("pages/charges/chargeSettlement/List"));
const ChargeSettlementDetailPage = React.lazy(() => import("pages/charges/chargeSettlement/Detail"));

// payable-charge
const PayableChargePage = React.lazy(() => import("pages/charges/payableCharges/List"));
const CreatePayableChargePage = React.lazy(() => import("pages/charges/payableCharges/CreateForm"));
const ChargePayableDetailPage = React.lazy(() => import("pages/charges/payableCharges/Detail"));
const UpdatePayableChargePage = React.lazy(() => import("pages/charges/payableCharges/UpdateForm"));

// Limit Configuration
// const LimitConfigPage = React.lazy(() => import("pages/registration/limitConfig/List"));
// const LimitConfigCreateForm = React.lazy(() => import("pages/registration/limitConfig/CreateForm"));
// const LimitConfigDetailPage = React.lazy(() => import("pages/registration/limitConfig/Details"));
// const LimitConfigUpdateForm = React.lazy(() => import("pages/registration/limitConfig/UpdateForm"));

// Limit Configuration V2
const LimitConfigV2Page = React.lazy(() => import("pages/registration/aggregateLimitConfig/List"));
const LimitConfigV2DetailsPage = React.lazy(() => import("pages/registration/aggregateLimitConfig/Details"));
const LimitConfigV2CreatePage = React.lazy(() => import("pages/registration/aggregateLimitConfig/CreateForm"));
const LimitConfigV2UpdatePage = React.lazy(() => import("pages/registration/aggregateLimitConfig/UpdateForm"));

// bulk Limit Configuration
const BulkLimitConfigFileListPage = React.lazy(() => import("pages/registration/bulkLimitConfig/List"));
const BulkLimitConfigFileDetailPage = React.lazy(() => import("pages/registration/bulkLimitConfig/Detail"));

//Buyer Seller

const BuyerSellerPage = React.lazy(() => import("pages/registration/buyerSeller/List"));
const CreateBuyerSellerPage = React.lazy(() => import("pages/registration/buyerSeller/CreateForm"));
const BuyerSellerDetailPage = React.lazy(() => import("pages/registration/buyerSeller/Detail"));
const BuyerSellerUpdateForm = React.lazy(() => import("pages/registration/buyerSeller/UpdateForm"));

//Bulk Buyer Seller
const BulkBuyerSellerPage = React.lazy(() => import("pages/registration/bulkBuyerSeller/List"));
const BulkBuyerSellerDetailPage = React.lazy(() => import("pages/registration/bulkBuyerSeller/Detail"));

//Bulk Beneficiary
const BulkBeneficiaryPage = React.lazy(() => import("pages/registration/bulkBeneficiary/List"));
const BulkBeneficiaryDetailPage = React.lazy(() => import("pages/registration/bulkBeneficiary/Detail"));

const instrumentBatchListPage = React.lazy(() => import("pages/transaction/instrumentBatch/List"));
const InstrumentBatchUploadListPage = React.lazy(() => import("pages/transaction/instrumentBatchUpload/List"));
const InstrumentBatchUploadDetailPage = React.lazy(() => import("pages/transaction/instrumentBatchUpload/Detail"));
const CreateInVoicePage = React.lazy(() => import("pages/transaction/instrumentBatch/CreateForm"));
const instrumnetBatchDetailPage = React.lazy(() => import("pages/transaction/instrumentBatch/Detail"));
const stagingBatchListPage = React.lazy(() => import("pages/transaction/stagingBatch/List"));
const stagingBatchDetailPage = React.lazy(() => import("pages/transaction/stagingBatch/Detail"));
const stagingInstrumentListPage = React.lazy(() => import("pages/transaction/stagingInstrument/List"));
const paymentBatchListPage = React.lazy(() => import("pages/transaction/paymentBatch/List"));
const paymentBatchDetailPage = React.lazy(() => import("pages/transaction/paymentBatch/Detail"));
const paymentInstrumentDetailPage = React.lazy(() => import("pages/transaction/paymentInstrument/Detail"));
const paymentInstrumentListPage = React.lazy(() => import("pages/transaction/paymentInstrument/List"));

// const InVoiceUpdateForm = React.lazy(() => import("pages/transaction/instrumentBatch/UpdateForm"));

//Strategy
const StrategyBatchList = React.lazy(() => import("pages/transaction/stagingBatch/List"));

const StagingDetailsPage = React.lazy(() => import("pages/transaction/stagingBatch/Detail"));

const instrumentListPage = React.lazy(() => import("pages/transaction/instrument/List"));

const instrumentDetailPage = React.lazy(() => import("pages/transaction/instrument/Details"));

// const InvoicesBatchRelatediniDetailPage = React.lazy(() => import("pages/transaction/Instrument/Details"));
// const InvoicesBatchRelatediniUpdateForm = React.lazy(() => import("pages/transaction/Instrument/UpdateForm"));

const StagingBatchInstrumentListPage = React.lazy(() => import("pages/transaction/stagingInstrument/List"));
const StagingBatchInstrumentDetailPage = React.lazy(() => import("pages/transaction/stagingInstrument/Details"));

//
const InterestAccrualListPage = React.lazy(() => import("pages/transaction/interestAccrual/List"));
const DailyBalancesListPage = React.lazy(() => import("pages/transaction/dailyBalances/List"));
const InterestAccrualDetailPage = React.lazy(() => import("pages/transaction/interestAccrual/Detail"));
const DailyBalancesDetailPage = React.lazy(() => import("pages/transaction/dailyBalances/Detail"));

//repayment-request
const repaymentListPage = React.lazy(() => import("pages/repayment/repayment-request/List"));

const repaymentDetailPage = React.lazy(() => import("pages/repayment/repayment-request/Detail"));

//repayment-bulk-request
const repaymentBulkRequestListPage = React.lazy(() => import("pages/repayment/repayment-intrument-bulk-request/List"));
const repaymentBulkRequestDetailPage = React.lazy(() => import("pages/repayment/repayment-intrument-bulk-request/Detail"));

const RepaymentAdjumentEntriesDetailsPage = React.lazy(() => import("pages/repayment/repayment-request/DetailRepaymentAdjustmentEntries"));
const RepaymentStagedAdjumentEntriesDetailsPage = React.lazy(() => import("pages/repayment/repayment-request/DetailRepaymentStagedAdjustmentEntries"));
const RepaymentChargeSettlementDetailsPage = React.lazy(() => import("pages/repayment/repayment-request/ChargeSettlementDetail"));

//excess-money
const excessMoneyListPage = React.lazy(() => import("pages/repayment/excess-money/List"));
const excessMoneyDetailPage = React.lazy(() => import("pages/repayment/excess-money/Detail"));

//excess-money-sattlement
const excessMoneySettlementListPage = React.lazy(() => import("pages/repayment/excess-money-sattlement/List"));
const excessMoneySettlementDetailsPage = React.lazy(() => import("pages/repayment/excess-money-sattlement/Detail"));

// excess-refund
const excessRefundListPage = React.lazy(() => import("pages/repayment/excess-refund/List"));
const excessRefundDetailsPage = React.lazy(() => import("pages/repayment/excess-refund/Detail"));

const InstrumentBalancesDailyHistoryDetailsPage = React.lazy(() => import("pages/transaction/instrumentBalancesDailyHistory/Detail"));
const InstrumentBalancesDailyHistoryListPage = React.lazy(() => import("pages/transaction/instrumentBalancesDailyHistory/List"));

const DisbursedmentAuthorizationDetailPage = React.lazy(() => import("pages/transaction/disburseAuth/Detail"));
const DisbursedmenAuthorizationtPage = React.lazy(() => import("pages/transaction/disburseAuth/List"));

const CreateDisbursementAdvicePage = React.lazy(() => import("pages/reports/disbursementAdvice/CreateForm"));
const CreateLimitReportPage = React.lazy(() => import("pages/reports/limitReport/CreateForm"));
const CreateClientSummaryPage = React.lazy(() => import("pages/reports/clientSummary/CreateForm"));
const CreateProgrammeSummaryPage = React.lazy(() => import("pages/reports/programmeSummary/CreateForm"));
const CreateInterestComputationPage = React.lazy(() => import("pages/reports/interestComputation/CreateForm"));
const CreateNpaReportPage = React.lazy(() => import("pages/reports/npaReport/CreateForm"));
const CreateRepaymentAdvicePage = React.lazy(() => import("pages/reports/repaymentAdvice/CreateForm"));
const CreateLifeCyclePage = React.lazy(() => import("pages/reports/lifeCycleReport/CreateForm"));
const CreateFundingDetailsPage = React.lazy(() => import("pages/reports/fundingDetails/CreateForm"));
const CreateOverdueReportPage = React.lazy(() => import("pages/reports/overdueReport/createForm"));
const CreateIntegLogReportPage = React.lazy(() => import("pages/reports/integLogReport/createForm"));
const CreateStatementOfAccountsPage = React.lazy(() => import("pages/reports/statementOfAccounts/CreateForm"));
const CreateUnrealisedIncomeReportPage = React.lazy(() => import("pages/reports/unRealisedIncome/CreateForm"));
const CreateOneViewReportPage = React.lazy(() => import("pages/reports/oneViewReport/CreateForm"));
const CreateChargeSummaryReportPage = React.lazy(() => import("pages/reports/chargeSummary/CreateForm"));
const CreateAmortizationReportPage = React.lazy(() => import("pages/reports/amortizationReport/CreateForm"));
const CreateBuyerSellerDumpReportPage = React.lazy(() => import("pages/reports/buyerSellerDump/CreateForm"));
const CreateProgrammesDumpReportPage = React.lazy(() => import("pages/reports/programmesDump/CreateForm"));
const CreateCustomerDumpReportPage = React.lazy(() => import("pages/reports/customerDump/CreateForm"));
const CreateCrilicReportPage = React.lazy(() => import("pages/reports/crilicReport/createForm"));

// Login Info
const LoginInfoPage = React.lazy(() => import("pages/systemInfo/LoginInfo"));

const loading = () => <div className=""></div>;

type LoadComponentProps = {
  component: React.LazyExoticComponent<React.ComponentType<any>>;
  fallback?: React.ReactNode;
};

function LoadComponent({ component: Component, fallback = loading(), ...props }: LoadComponentProps) {
  return (
    <Suspense fallback={fallback}>
      <Component {...props} />
    </Suspense>
  );
}

const AllRoutes = () => {
  const { appSelector } = useRedux();

  const { layout } = appSelector(state => ({
    layout: state.Layout
  }));

  const getLayout = () => {
    let layoutCls: React.ComponentType = VerticalLayout;

    switch (layout.layoutType) {
      case LayoutTypes.LAYOUT_HORIZONTAL:
        layoutCls = HorizontalLayout;
        break;
      case LayoutTypes.LAYOUT_DETACHED:
        layoutCls = DetachedLayout;
        break;
      case LayoutTypes.LAYOUT_FULL:
        layoutCls = FullLayout;
        break;
      default:
        layoutCls = VerticalLayout;
        break;
    }
    return layoutCls;
  };
  let Layout = getLayout();

  return useRoutes([
    { path: "/", element: <Root /> },
    {
      // public routes
      path: "/",
      element: <DefaultLayout />,
      children: [
        {
          path: "account",
          children: [
            { path: "login", element: <LoadComponent component={Login} /> },
            { path: "register", element: <LoadComponent component={Register} /> },
            { path: "confirm", element: <LoadComponent component={Confirm} /> },
            { path: "forget-password", element: <LoadComponent component={ForgetPassword} /> },
            { path: "lock-screen", element: <LoadComponent component={LockScreen} /> },
            { path: "logout", element: <LoadComponent component={Logout} /> },
            { path: "register2", element: <LoadComponent component={Register2} /> },
            { path: "confirm2", element: <LoadComponent component={Confirm2} /> },
            { path: "forget-password2", element: <LoadComponent component={ForgetPassword2} /> },
            { path: "lock-screen2", element: <LoadComponent component={LockScreen2} /> },
            { path: "logout2", element: <LoadComponent component={Logout2} /> },
            { path: "sso/callback", element: <LoadComponent component={SSOConsumeRedirect} /> },
            { path: "sso/otp", element: <LoadComponent component={SSOOtpHandle} /> }

          ]
        },
        {
          path: "*",
          element: <LoadComponent component={ErrorPageNotFoundSecondary} />
        },
        {
          path: "error-404",
          element: <LoadComponent component={ErrorPageNotFound} />
        },
        {
          path: "error-401",
          element: <LoadComponent component={unAuthorizedPage} />
        },
        {
          path: "access-denied",
          element: <LoadComponent component={unAuthorizedPage} />
        },
        {
          path: "error-500",
          element: <LoadComponent component={ServerError} />
        }
      ]
    },
    {
      // auth protected routes
      path: "/",
      element: <PrivateRoute component={Layout} />,
      children: [
        {
          path: "dashboard",
          children: [
            {
              path: "my",
              element: <LoadComponent component={DashBoardPage} />
            }
          ]
        },
        {
          path: "master",
          children: [
            {
              path: "users",
              element: <LoadComponent component={UserPage} />
            },
            {
              path: "users/create",
              element: <LoadComponent component={CreateUserPage} />
            },
            {
              path: "users/edit/:id",
              element: <LoadComponent component={UpdateUserPage} />
            },
            {
              path: "users/detail/:id/:internalid",
              element: <LoadComponent component={DetailUserPage} />
            },
            //roles
            {
              path: "roles",
              element: <LoadComponent component={UserRolePage} />
            },
            {
              path: "roles/create",
              element: <LoadComponent component={CreateUserRolePage} />
            },
            {
              path: "roles/edit/:id",
              element: <LoadComponent component={UpdateUserRolePage} />
            },
            {
              path: "roles/detail/:id/:internalid",
              element: <LoadComponent component={DetailUserRolePage} />
            },

            {
              path: "currencies",
              element: <LoadComponent component={CurrencyPage} />
            },
            {
              path: "currencies/create",
              element: <LoadComponent component={CreateCurrencyPage} />
            },
            {
              path: "currencies/detail/:id/:internalid",
              element: <LoadComponent component={DetailCurrencyPage} />
            },
            {
              path: "currencies/edit/:id",
              element: <LoadComponent component={UpdateCurrencyPage} />
            },
            {
              path: "base-rates",
              element: <LoadComponent component={BaseRatePage} />
            },

            {
              path: "base-rates/create",
              element: <LoadComponent component={CreateBaseRatePage} />
            },
            {
              path: "base-rates/detail/:id/:internalid",
              element: <LoadComponent component={DetailBaseRatePage} />
            },
            {
              path: "base-rates/edit/:id",
              element: <LoadComponent component={UpdateBaseRatePage} />
            },
            {
              path: "holidays",
              element: <LoadComponent component={HolidayPage} />
            },
            {
              path: "holidays/create",
              element: <LoadComponent component={CreateHolidayPage} />
            },
            {
              path: "holidays/detail/:id/:internalid",
              element: <LoadComponent component={DetailHolidayPage} />
            },
            {
              path: "holidays/edit/:id",
              element: <LoadComponent component={UpdateHolidayPage} />
            },

            {
              path: "holiday-batch",
              element: <LoadComponent component={HolidayBatchPage} />
            },
            // {
            //   path: "holidays/create",
            //   element: <LoadComponent component={CreateHolidayPage} />
            // },
            {
              path: "holiday-batch/detail/:id/:internalid",
              element: <LoadComponent component={DetailHolidayBatchPage} />
            },
            {
              path: "holiday-batch/edit/:id",
              element: <LoadComponent component={UpdateHolidayBatchPage} />
            },
            {
              path: "branch",
              element: <LoadComponent component={BranchPage} />
            },
            {
              path: "branch/create",
              element: <LoadComponent component={CreateBranchPage} />
            },
            {
              path: "branch/detail/:id/:internalid",
              element: <LoadComponent component={DetailBranchPage} />
            },
            {
              path: "branch/edit/:id",
              element: <LoadComponent component={UpdateBranchPage} />
            },
            {
              path: "country",
              element: <LoadComponent component={CountryPage} />
            },
            {
              path: "country/create",
              element: <LoadComponent component={CreateCountryPage} />
            },
            {
              path: "country/detail/:id/:internalid",
              element: <LoadComponent component={DeatilCountryPage} />
            },
            {
              path: "country/edit/:id",
              element: <LoadComponent component={UpdateCountryPage} />
            },

            {
              path: "relationshipManagers",
              element: <LoadComponent component={RMPage} />
            },
            {
              path: "relationshipManagers/create",
              element: <LoadComponent component={RMCreatePage} />
            },
            {
              path: "relationshipManagers/edit/:id",
              element: <LoadComponent component={RMUpdatePage} />
            },
            {
              path: "relationshipManagers/detail/:id/:internalid",
              element: <LoadComponent component={RMDetailPage} />
            },

            {
              path: "state",
              element: <LoadComponent component={StatePage} />
            },
            {
              path: "state/create",
              element: <LoadComponent component={CreateStatePage} />
            },
            {
              path: "state/detail/:id/:internalid",
              element: <LoadComponent component={DetailStatePage} />
            },
            {
              path: "state/edit/:id",
              element: <LoadComponent component={UpdateStatePage} />
            },
            {
              path: "city",
              element: <LoadComponent component={CityPage} />
            },
            {
              path: "city/create",
              element: <LoadComponent component={CreateCityPage} />
            },
            {
              path: "city/detail/:id/:internalid",
              element: <LoadComponent component={DetailCityPage} />
            },
            {
              path: "city/edit/:id",
              element: <LoadComponent component={UpdateCityPage} />
            },
            // LOV

            {
              path: "lov",
              element: <LoadComponent component={LOVPage} />
            },
            {
              path: "lov/create",
              element: <LoadComponent component={CreateLOVPage} />
            },
            {
              path: "lov/detail/:id/:internalid",
              element: <LoadComponent component={LOVDetailPage} />
            },
            {
              path: "lov/edit/:id",
              element: <LoadComponent component={UpdateLOVPage} />
            },

            //product-type

            {
              path: "product-type",
              element: <LoadComponent component={productTypePage} />
            },
            {
              path: "product-type/create",
              element: <LoadComponent component={CreateproductTypePage} />
            },
            {
              path: "product-type/detail/:id/:internalid",
              element: <LoadComponent component={ProductTypeDetailPage} />
            },
            {
              path: "product-type/edit/:id",
              element: <LoadComponent component={UpdateproductTypePage} />
            },
            //Gl Account
            {
              path: "glaccount",
              element: <LoadComponent component={GlAccountListPage} />
            },
            {
              path: "glaccount/create",
              element: <LoadComponent component={CreateGlAccountPage} />
            },
            {
              path: "glaccount/detail/:id/:internalid",
              element: <LoadComponent component={GlAccountDetailPage} />
            },
            {
              path: "glaccount/edit/:id",
              element: <LoadComponent component={UpdateGlAccountPage} />
            },

            //co-lender
            {
              path: "co-lender-financiers",
              element: <LoadComponent component={CoLenderFinancierListPage} />,
            },
            {
              path: "co-lender-financiers/create",
              element: <LoadComponent component={CreateCoLenderFinancierPage} />,
            },
            {
              path: "co-lender-financiers/detail/:id/:internalid",
              element: <LoadComponent component={CoLenderFinancierDetailPage} />,
            },
            {
              path: "co-lender-financiers/edit/:id",
              element: <LoadComponent component={UpdateCoLenderFinancierPage} />,
            },

            // system-parameters
            {
              path: "system-parameters",
              element: <LoadComponent component={SystemParametersPage} />
            },
            {
              path: "system-parameters/detail/:id/:internalid",
              element: <LoadComponent component={DetailSystemParameterPage} />
            },
            {
              path: "system-parameters/edit/:id",
              element: <LoadComponent component={UpdateSystemParameterPage} />
            },
          ]
        },
        {
          path: "registration",
          children: [
            // customers
            {
              path: "customers",
              element: <LoadComponent component={CustomersPage} />
            },
            {
              path: "customers/create",
              element: <LoadComponent component={CreateCustomersPage} />
            },
            {
              path: "customers/detail/:id/:internalid",
              element: <LoadComponent component={customerDetailPage} />
            },
            {
              path: "customers/edit/:id",
              element: <LoadComponent component={UpdateCustomerPage} />
            },

            //customer CIC Reporting
            {
              path: "customer-cic-reporting",
              element: <LoadComponent component={CustomerCICReportingPage} />
            },
            {
              path: "customer-cic-reporting/create",
              element: <LoadComponent component={CreateCustomerCICReportingPage} />
            },
            {
              path: "customer-cic-reporting/edit/:id",
              element: <LoadComponent component={UpdateCustomerCICReportingPage} />
            },
            {
              path: "customer-cic-reporting/detail/:id/:internalId",
              element: <LoadComponent component={CustomerCICReportingDetailPage} />
            },

            // bulk-customers
            {
              path: "bulk-customers",
              element: <LoadComponent component={BulkCustomersListPage} />
            },
            {
              path: "bulk-customers/detail/:id/:internalid",
              element: <LoadComponent component={BulkCustomersDetailPage} />
            },

            // bulk-customer-cic-reporting
            {
              path: "bulk-customer-cic-reporting",
              element: <LoadComponent component={BulkCustomerCicReportingListPage} />
            },
            {
              path: "bulk-customer-cic-reporting/detail/:id/:internalid",
              element: <LoadComponent component={BulkCustomerCicReportingDetailPage} />
            },

            //Programme
            {
              path: "programme",
              element: <LoadComponent component={programmePage} />
            },
            {
              path: "programme/create",
              element: <LoadComponent component={CreateProgrammePage} />
            },

            {
              path: "programme/detail/:id/:internalid",
              element: <LoadComponent component={ProgrammeDetailPage} />
            },
            {
              path: "programme/edit/:id",
              element: <LoadComponent component={UpdateProgrammePage} />
            },

            //Bulk Programme
            {
              path: "bulk-programme",
              element: <LoadComponent component={bulkProgrammePage} />
            },
            {
              path: "bulk-programme/detail/:id/:internalid",
              element: <LoadComponent component={bulkProgrammeDetailPage} />
            },
            {
              path: "promoter-director/detail/:id/:customerId/:internalid",
              element: <LoadComponent component={PromoterDirectorDetailPage} />
            },
            {
              path: "promoter-director/edit/:id/:customerId/",
              element: <LoadComponent component={PromoterDirectorUpdateForm} />
            },
            {
              path: "key-management/detail/:id/:customerId",
              element: <LoadComponent component={KeyManagementPersonnelDetailPage} />
            },
            {
              path: "key-management/edit/:id/:customerId",
              element: <LoadComponent component={KeyManagementPersonnelUpdateForm} />
            },
            {
              path: "partner/detail/:id/:customerId",
              element: <LoadComponent component={PartnerDetailPage} />
            },
            {
              path: "partner/edit/:id/:customerId",
              element: <LoadComponent component={PartnerUpdateForm} />
            },

            {
              path: "communications/detail/:id/:customerId/:internalid",
              element: <LoadComponent component={CustomerCummicationsDetailPage} />
            },
            {
              path: "communications/edit/:id/:customerId",
              element: <LoadComponent component={UpdateCustomerCummicationsPage} />
            },

            //address
            {
              path: "address/detail/:id/:customerId/:internalid",
              element: <LoadComponent component={AddressDetailPage} />
            },
            {
              path: "address/edit/:id/:customerId",
              element: <LoadComponent component={AddressUpdateForm} />
            },

            //limit config
            // {
            //   path: "limit-config",
            //   element: <LoadComponent component={LimitConfigPage} />
            // },
            // {
            //   path: "limit-config/create",
            //   element: <LoadComponent component={LimitConfigCreateForm} />
            // },
            // {
            //   path: "limit-config/detail/:customerId/:id/:internalid",
            //   element: <LoadComponent component={LimitConfigDetailPage} />
            // },
            // {
            //   path: "limit-config/edit/:customerId/:id",
            //   element: <LoadComponent component={LimitConfigUpdateForm} />
            // },

            //limit config v2
            {
              path: "limit-config-v2",
              element: <LoadComponent component={LimitConfigV2Page} />
            },
            {
              path: "limit-config-v2/detail/:customerId",
              element: <LoadComponent component={LimitConfigV2DetailsPage} />
            },
            {
              path: "limit-config-v2/create",
              element: <LoadComponent component={LimitConfigV2CreatePage} />
            },
            {
              path: "limit-config-v2/edit/:customerId",
              element: <LoadComponent component={LimitConfigV2UpdatePage} />
            },

            //bulk limit config
            {
              path: "bulk-limit-config",
              element: <LoadComponent component={BulkLimitConfigFileListPage} />
            },
            {
              path: "bulk-limit-config/detail/:id/:internalid",
              element: <LoadComponent component={BulkLimitConfigFileDetailPage} />
            },

            //beneficiary

            {
              path: "customer-beneficiary/detail/:id/:customerId/:internalid",
              element: <LoadComponent component={beneficiaryDetailPage} />
            },

            {
              path: "customer-beneficiary-programme/detail/:id/:customerId",
              element: <LoadComponent component={beneficiaryProgrammeDetailPage} />
            },
            {
              path: "customer-beneficiary-programme/edit/:id/:customerId",
              element: <LoadComponent component={CustomerBeneficiaryProgrammeUpdateForm} />
            },

            //buyer-seller
            {
              path: "buyer-seller",
              element: <LoadComponent component={BuyerSellerPage} />
            },
            {
              path: "buyer-seller/create",
              element: <LoadComponent component={CreateBuyerSellerPage} />
            },
            {
              path: "buyer-seller/detail/:id/:internalid",
              element: <LoadComponent component={BuyerSellerDetailPage} />
            },
            {
              path: "buyer-seller/edit/:id",
              element: <LoadComponent component={BuyerSellerUpdateForm} />
            },

            //bulk-buyer-seller
            {
              path: "bulk-buyer-seller",
              element: <LoadComponent component={BulkBuyerSellerPage} />
            },
            {
              path: "bulk-buyer-seller/detail/:id/:internalid",
              element: <LoadComponent component={BulkBuyerSellerDetailPage} />
            },

            //bulk-beneficiary
            {
              path: "bulk-beneficiary",
              element: <LoadComponent component={BulkBeneficiaryPage} />
            },
            {
              path: "bulk-beneficiary/detail/:id/:internalid",
              element: <LoadComponent component={BulkBeneficiaryDetailPage} />
            }
          ]
        },
        {
          path: "charges",
          children: [
            //Receivable charge
            {
              path: "receivable-charge",
              element: <LoadComponent component={ReceivableChargeListPage} />
            },
            {
              path: "receivable-charge/create",
              element: <LoadComponent component={CreateReceivableChargePage} />
            },
            {
              path: "receivable-charge/detail/:id/:internalid",
              element: <LoadComponent component={ReceivableChargeDetailPage} />
            },
            {
              path: "receivable-charge/edit/:id",
              element: <LoadComponent component={UpdateReceivableChargePage} />
            },

            //payable-charge
            {
              path: "payable-charge",
              element: <LoadComponent component={PayableChargePage} />
            },
            {
              path: "payable-charge/create",
              element: <LoadComponent component={CreatePayableChargePage} />
            },
            {
              path: "payable-charge/detail/:id/:internalid",
              element: <LoadComponent component={ChargePayableDetailPage} />
            },
            {
              path: "payable-charge/edit/:id",
              element: <LoadComponent component={UpdatePayableChargePage} />
            },
            // Charge Settlement
            {
              path: "charge-settlement",
              element: <LoadComponent component={ChargeSettlementListPage} />
            },
            {
              path: "charge-settlement/detail/:id",
              element: <LoadComponent component={ChargeSettlementDetailPage} />
            }
          ]
        },
        {
          path: "transaction",
          children: [
            {
              path: "instrument-batch",
              element: <LoadComponent component={instrumentBatchListPage} />
            },
            {
              path: "instrument-batch/create",
              element: <LoadComponent component={CreateInVoicePage} />
            },
            {
              path: "instrument-batch/detail/:externalId",
              element: <LoadComponent component={instrumnetBatchDetailPage} />
            },
            {
              path: "instrument-batch-upload",
              element: <LoadComponent component={InstrumentBatchUploadListPage} />
            },
            {
              path: "instrument-batch-upload/detail/:id",
              element: <LoadComponent component={InstrumentBatchUploadDetailPage} />
            },
            {
              path: "instrument",
              element: <LoadComponent component={instrumentListPage} />
            },

            {
              path: "instrument/detail/:id",
              element: <LoadComponent component={instrumentDetailPage} />
            },

            {
              path: "staging-batch",
              element: <LoadComponent component={stagingBatchListPage} />
            },
            {
              path: "staging-batch/detail/:externalId",
              element: <LoadComponent component={stagingBatchDetailPage} />
            },
            {
              path: "staging-instrument",
              element: <LoadComponent component={stagingInstrumentListPage} />
            },

            {
              path: "staging-instrument/detail/:externalId",
              element: <LoadComponent component={StagingBatchInstrumentDetailPage} />
            },
            {
              path: "payment-batch",
              element: <LoadComponent component={paymentBatchListPage} />
            },
            {
              path: "payment-batch/detail/:externalId",
              element: <LoadComponent component={paymentBatchDetailPage} />
            },
            {
              path: "payment-instrument",
              element: <LoadComponent component={paymentInstrumentListPage} />
            },
            {
              path: "payment-instrument/detail/:externalId",
              element: <LoadComponent component={paymentInstrumentDetailPage} />
            },
            ///
            {
              path: "interest-accrual",
              element: <LoadComponent component={InterestAccrualListPage} />
            },
            {
              path: "interest-accrual/detail/:externalId",
              element: <LoadComponent component={InterestAccrualDetailPage} />
            },
            //
            {
              path: "instrument-balances-daily-history",
              element: <LoadComponent component={InstrumentBalancesDailyHistoryListPage} />
            },
            {
              path: "instrument-balances-daily-history/detail/:externalId",
              element: <LoadComponent component={InstrumentBalancesDailyHistoryDetailsPage} />
            },

            //
            {
              path: "daily-balances",
              element: <LoadComponent component={DailyBalancesListPage} />
            },
            {
              path: "daily-balances/detail/:externalId",
              element: <LoadComponent component={DailyBalancesDetailPage} />
            },

            //disbursed auth

            {
              path: "disbursement-authorization",
              element: <LoadComponent component={DisbursedmenAuthorizationtPage} />
            },
            {
              path: "disbursement-authorization/detail/:externalId",
              element: <LoadComponent component={DisbursedmentAuthorizationDetailPage} />
            }
          ]
        },

        //repaymet
        {
          path: "repayment",
          children: [
            {
              path: "repayment-request",
              element: <LoadComponent component={repaymentListPage} />
            },
            {
              path: "repayment-request/detail/:id",
              element: <LoadComponent component={repaymentDetailPage} />
            },
            {
              path: "repayment-intrument-bulk-request",
              element: <LoadComponent component={repaymentBulkRequestListPage} />
            },
            {
              path: "repayment-intrument-bulk-request/detail/:id",
              element: <LoadComponent component={repaymentBulkRequestDetailPage} />
            },
            {
              path: "repayment-adjuement-entries/detail/:id",
              element: <LoadComponent component={RepaymentAdjumentEntriesDetailsPage} />
            },
            {
              path: "repayment-staged-adjuement-entries/detail/:id",
              element: <LoadComponent component={RepaymentStagedAdjumentEntriesDetailsPage} />
            },
            {
              path: "repayment-charges-settlement/detail/:id",
              element: <LoadComponent component={RepaymentChargeSettlementDetailsPage} />
            },
            {
              path: "excess-money",
              element: <LoadComponent component={excessMoneyListPage} />
            },
            {
              path: "excess-money/detail/:id",
              element: <LoadComponent component={excessMoneyDetailPage} />
            },
            {
              path: "excess-money-settlements",
              element: <LoadComponent component={excessMoneySettlementListPage} />
            },
            {
              path: "excess-money-settlements/detail/:id",
              element: <LoadComponent component={excessMoneySettlementDetailsPage} />
            },
            {
              path: "excess-refund",
              element: <LoadComponent component={excessRefundListPage} />
            },
            {
              path: "excess-refund/detail/:id",
              element: <LoadComponent component={excessRefundDetailsPage} />
            }
          ]
        },
        //reports
        {
          path: "report",
          children: [
            {
              path: "disbursement-advice/create",
              element: <LoadComponent component={CreateDisbursementAdvicePage} />
            },
            {
              path: "limit/create",
              element: <LoadComponent component={CreateLimitReportPage} />
            },
            {
              path: "client-summary/create",
              element: <LoadComponent component={CreateClientSummaryPage} />
            },
            {
              path: "interest-computation/create",
              element: <LoadComponent component={CreateInterestComputationPage} />
            },
            {
              path: "repayment-advice/create",
              element: <LoadComponent component={CreateRepaymentAdvicePage} />
            },
            {
              path: "program-summary/create",
              element: <LoadComponent component={CreateProgrammeSummaryPage} />
            },
            {
              path: "npa-report/create",
              element: <LoadComponent component={CreateNpaReportPage} />
            },
            {
              path: "life-cycle/create",
              element: <LoadComponent component={CreateLifeCyclePage} />
            },
            {
              path: "funding-details/create",
              element: <LoadComponent component={CreateFundingDetailsPage} />
            },
            {
              path: "overdue-report/create",
              element: <LoadComponent component={CreateOverdueReportPage} />
            },
            {
              path: "integ-log-report/create",
              element: <LoadComponent component={CreateIntegLogReportPage} />
            },
            {
              path:"crilic-report/create",
              element:<LoadComponent component={CreateCrilicReportPage} />
            },
            {
              path: "statement-of-accounts/create",
              element: <LoadComponent component={CreateStatementOfAccountsPage} />
            },
            {
              path: "unrealised-income-report/create",
              element: <LoadComponent component={CreateUnrealisedIncomeReportPage} />
            },
            {
              path: "one-view-report/create",
              element: <LoadComponent component={CreateOneViewReportPage} />
            },
            {
              path: "charge-summary-report/create",
              element: <LoadComponent component={CreateChargeSummaryReportPage} />
            },
            {
              path: "amortization-report/create",
              element: <LoadComponent component={CreateAmortizationReportPage} />
            },
            {
              path: "buyer-seller-dump-report/create",
              element: <LoadComponent component={CreateBuyerSellerDumpReportPage} />
            },
            {
              path: "programmes-dump-report/create",
              element: <LoadComponent component={CreateProgrammesDumpReportPage} />
            },
            {
              path: "customer-dump-report/create",
              element: <LoadComponent component={CreateCustomerDumpReportPage} />
            }
          ]
        },
        {
          path: "system-info",
          children: [
            {
              path: "login-info",
              element: <LoadComponent component={LoginInfoPage} />
            }
          ]
        },
        {
          path: "pages",
          children: [
            {
              path: "error-404-alt",
              element: <LoadComponent component={ErrorPageNotFoundAlt} />
            }
          ]
        }
      ]
    }
  ]);
};

export { AllRoutes };
